import { useIntl } from 'react-intl';

// MUI
import Paper from '@mui/material/Paper';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Divider from '@mui/material/Divider';

// screen
import { useAccountCreateForm } from 'modules/account/create/useAccountCreateForm';
import { AccountCreateProvider } from 'modules/account/create/AccountCreateContext';
import { ACCOUNT_CREATE_STEPS, type StepIndex } from 'modules/account/create/steps/stepsConfig';

const AccountCreatePage = () => {
  const { formatMessage } = useIntl();
  const form = useAccountCreateForm();

  return (
    <AccountCreateProvider value={form}>
      <Paper className="p-2 tablet:p-4">
        <Stepper activeStep={form.state.activeStep} alternativeLabel>
          {ACCOUNT_CREATE_STEPS.map((cfg) => (
            <Step key={cfg.index}>
              <StepLabel>{formatMessage({ id: cfg.labelId })}</StepLabel>
            </Step>
          ))}
        </Stepper>

        <Divider sx={{ marginY: '24px' }} />

        <StepContent stepIndex={form.state.activeStep} />
      </Paper>
    </AccountCreateProvider>
  );
};

/** Render nội dung step theo registry - dễ mở rộng khi thêm step mới */
function StepContent({ stepIndex }: { stepIndex: StepIndex }) {
  const config = ACCOUNT_CREATE_STEPS.find((c) => c.index === stepIndex);
  if (!config) return null;

  const { Component } = config;
  return <Component />;
}

export default AccountCreatePage;
